import { PropsWithChildren } from 'react';

import Trustpilot from '~components/Trustpilot/Trustpilot';
import ZipForm from '~components/ZipCodeForm/ZipCodeForm';
import BBB from '~images/inline/BBB.inline.svg';

import SpeakWithAgent from '../child-blocks/SpeakWithAgent';

interface IProps {
    stateName: string | undefined;
    planYear: string | undefined;
    zipFormHeading?: string | undefined;
}

const ZipWithPhoneNumber = ({
    stateName = 'your state',
    planYear = '',
    zipFormHeading = '',
}: PropsWithChildren<IProps>) => {
    const heading = zipFormHeading || `Find ${planYear} Medicare Advantage plans in ${stateName}`;
    return (
        <>
            <section className="hero-paid-search-legacy-style">
                <h2 className="text-center lg:text-start">{heading}</h2>
                <div className="rounded-lg flex justify-center">
                    <div className="max-w-screen-xs md:max-w-screen-xl w-full md:px-3 lg:px-0">
                        <div className="md:mb-8 lg:mb-0">
                            <ZipForm
                                buttonTitle="See plans in my area"
                                buttonWaLink="Hero Paid Search: Zip with Phone Number: Compare Plan"
                                qaValue="Hero Zip with Phone Number"
                                opts={{
                                    btnStyle: 'primary',
                                    useWideLayout: true,
                                    isVerticalOnTablet: true,
                                }}
                            />
                        </div>

                        <div className="mt-6 md:mt-0">
                            <div className="grid grid-cols-12">
                                <div className="col-span-12">
                                    <SpeakWithAgent
                                        headingCopy="Or speak with an eHealth licensed insurance agent"
                                        fromComponentName="Hero Paid Seach: Zip with Phone Number"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-3 md:hidden flex justify-center">
                    <div className="mr-6">
                        <div className="norton-placeholder" id="DigiCertClickID_onwANETs_5"></div>
                    </div>
                    <div>
                        <BBB width={100} height={70} />
                    </div>
                </div>
            </section>
            <div className="py-6 lg:py-10">
                <Trustpilot size="newthin" />
            </div>
        </>
    );
};

export default ZipWithPhoneNumber;
